import { render } from "./FileVersionList.vue?vue&type=template&id=f5f8847e&scoped=true&lang=pug"
import script from "./FileVersionList.vue?vue&type=script&lang=js"
export * from "./FileVersionList.vue?vue&type=script&lang=js"

import "./FileVersionList.vue?vue&type=style&index=0&id=f5f8847e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f8847e"]])

export default __exports__